import { memo } from 'react';

interface FilterOption {
  value: string;
  label: string;
  count: number;
}

interface StatusFiltersProps {
  filters: FilterOption[];
  selectedFilter: string;
  onFilterChange: (value: string) => void;
}

const StatusFilters = memo(({ filters, selectedFilter, onFilterChange }: StatusFiltersProps) => {
  return (
    <div className="border-t pt-4">
      <p className="text-sm font-medium text-gray-700 mb-3">Filter by Type:</p>
      <div className="flex flex-wrap gap-2">
        {filters.map((filter) => (
          <button
            key={filter.value}
            onClick={() => onFilterChange(filter.value)}
            className={`px-3 py-2 rounded-lg text-sm font-medium border transition-colors ${
              selectedFilter === filter.value
                ? 'bg-indigo-100 text-indigo-800 border-indigo-200'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
          >
            {filter.label} ({filter.count})
          </button>
        ))}
      </div>
    </div>
  );
});

StatusFilters.displayName = 'StatusFilters';

export default StatusFilters;